<template>
 <div class="listDomain">
     <main class="t-main">
       <ol class="m-breadcrumb">
         <li class="m-breadcrumb__item"><span class="a-text">ドメイン一覧</span></li>
       </ol>
       <h1 class="a-title">{{ listDomainTitle }}</h1>
       <div class="m-form__item-wrapper">
         <button class="a-button" v-on:click="createDomainLink">新規登録</button>
       </div>
       <br/>
       <div class="a-section">
       <table class="m-table">
         <thead>
           <tr>
             <th>{{ columns.fqdn }}</th>
             <th>{{ columns.mtime }}</th>
             <th>{{ columns.utime }}</th>
             <th>{{ columns.delete }}</th>
           </tr>
         </thead>
         <tbody>
           <tr v-for="task in tasks">
            <td><router-link v-bind:to="{ path: 'update-domain', query: { fqdn: task.fqdn}}">{{ task.fqdn }}</router-link></td>
            <td>{{ task["mtime"] | moment }}</td>
            <td>{{ task["utime"] | moment }}</td>
            <td><a class="m-form__delete" v-on:click="deleteDomain(task)"></a></td>
           </tr>
         </tbody>
       </table>
      </div>
    </main>
  </div>
</template>

<script>

import store from '../../../stores'
import moment from 'moment'

export default {
  name: 'listDomain',
  data() {
    const columns = { fqdn: 'fqdn', mtime: '作成日時', utime: '更新日時', delete: '削除' }
    return { listDomainTitle: 'ドメイン一覧', columns }
  },
  created() {
    store.dispatch('checkSessionId')
    store.dispatch('getDomainListData')
  },
  // ajaxで取得してきた
  computed: { tasks: { get() { return store.state.domain.domainlist } } },
  methods: {
    callDomainList: function() {
      store.dispatch('domainlist', this.tasks)
    },
    createDomainLink: function() {
      this.$router.push('/delivery/create-domain')
    },
    deleteDomain: function(domain) {
      if (confirm(domain.fqdn + 'のバージョン' + domain.versionId + 'を削除しますか？')) {
        store.dispatch('domainDelete', domain)
      }
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/domain/ListDomain.vue